import { WorkspaceSwitcherItem } from "@components/navigation/WorkspaceSwitcherItem";
import { useSwitchToPersonalView } from "@hooks/useSwitchToPersonalView";
import { useOrganization } from "@api/organization.api";
import { FC } from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { OrganizationSwitcher } from "@components/navigation/OrganizationSwitcher";
import { ClientSwitcher } from "@components/navigation/ClientSwitcher";
import { useWorkspacesList } from "@api/workspace.api";

export const DefaultNavigationDropdownBody: FC = () => {
    const { data: userOrganization } = useOrganization();
    const goToPersonalView = useSwitchToPersonalView();
    const workspacesQuery = useWorkspacesList();
    const hasMultipleWorkspaces = workspacesQuery?.data?.length
        ? workspacesQuery.data.length > 1
        : false;
    const hasAccessToOrganization = userOrganization !== null;
    const showPersonalViewItem = !hasAccessToOrganization;

    if (hasMultipleWorkspaces && !hasAccessToOrganization) {
        return (
            <>
                <WorkspaceSwitcherItem />
                {showPersonalViewItem && (
                    <Menu.Item onClick={goToPersonalView}>
                        View all workspaces
                    </Menu.Item>
                )}
                <Menu.Separator />
            </>
        );
    }

    if (!hasAccessToOrganization) {
        return null;
    }

    return (
        <>
            <ClientSwitcher />
            <OrganizationSwitcher />
        </>
    );
};
